import React from 'react'
import { Grid, TextField } from '@mui/material'
import { FormInputRow } from '@emerald-works-nova/components'
import { useStyles } from './style'

const ExploreContentSectionForm = ({ section, onChange, isEdit }) => {
  const classes = useStyles()
  const { header } = section.data

  const handleFieldChange = (field, value) => {
    onChange(section.order, { ...section, data: { ...section.data, [field]: value } })
  }

  return (
    <Grid container spacing={2} className={classes.formContainer} data-test='explore-content-section-form-container'>
      <Grid item xs={12} data-test='explore-content-section-form-header-container'>
        <FormInputRow
          title='Header'
          description='Main heading for the explore content section'
          smallFormTitles
          className={classes.formField}
          InputComponent={
            <TextField
              fullWidth
              label='Header'
              value={header || ''}
              onChange={(e) => handleFieldChange('header', e.target.value)}
              variant='outlined'
              disabled={!isEdit}
              data-test='explore-content-section-form-header-input'
            />
          }
        />
      </Grid>
    </Grid>
  )
}

export default ExploreContentSectionForm
